import React from 'react';
import { useRecordContext } from 'react-admin';
import { Chip, Box } from '@mui/material';

interface KeyValueFieldProps {
    source: string;
    label?: string;
}

export const KeyValueField: React.FC<KeyValueFieldProps> = ({ source }) => {
    const record = useRecordContext();

    if (!record || !record[source]) {
        return <span>-</span>;
    }

    const data = record[source];

    if (typeof data !== 'object' || data === null) {
        return <span>{String(data)}</span>;
    }

    const entries = Object.entries(data);

    if (entries.length === 0) {
        return <span>-</span>;
    }

    return (
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', alignItems: 'center' }}>
            {entries.map(([key, value], index) => (
                <Chip
                    key={index}
                    label={`${key}: ${value}`}
                    size="small"
                    variant="outlined"
                    sx={{ fontSize: '0.75rem' }}
                />
            ))}
        </Box>
    );
};
